import { TRootState } from '../../../store';

export const getTab = (state: TRootState) => state.ui.settings.tab;
